import { render, staticRenderFns } from "./TareasList.vue?vue&type=template&id=26d214dc&"
import script from "./TareasList.vue?vue&type=script&lang=js&"
export * from "./TareasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports